<div class="ind-page-title">
  <div class="row px-4">
    <div class="col-12">
      <div class="d-flex justify-content-between">
        <div class="ind-breadcrumbs">
          <nav
            style="--bs-breadcrumb-divider: url(/icons/linear/right-arrow.svg)"
            aria-label="Document breadcrumb navigation"
          >
            <ol class="breadcrumb">
              <li [attr.aria-label]="'Documents'" class="breadcrumb-item">
                <a href="/documents" (keydown.enter)="onBack()"
                (keydown.space)="onBack()">Documents</a>
              </li>
              <!-- <li [attr.aria-label]="documentDetails?.businessName" class="breadcrumb-item active" aria-current="page" *ngIf="documentDetails?.businessName">{{documentDetails?.businessName}}</li> -->
              <li
                [attr.aria-label]="'Document Name'"
                class="breadcrumb-item active ind-document-name-label"
                aria-current="page"
              >
                <img alt="Document Icon" src="icons/bold/document-text.svg" />
                <span>{{ documentDetails.name }}</span>
              </li>
            </ol>
          </nav>
        </div>
        <div>
          <app-button
            (click)="onPdfExpand()"
            
            type="outline-dark"
            iconAlt="Export PDF Button"
            iconImg="/icons/linear/export-outline.svg"
            class="ind-button-md"
            label="Export Pages"
            (keydown.enter)="onPdfExpand()"
            (keydown.space)="onPdfExpand()"
          ></app-button>
          <app-button
            (click)="onBack()"
            (keydown.enter)="onBack()"
            (keydown.space)="onBack()"
            type="outline-dark"
            iconAlt="Back"
            iconImg="/icons/linear/arrow-left-outline.svg"
            class="ind-button-md"
            label="Back"
          ></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid" id="main">
  <div class="row p-0">
    <div class="col-12">
      @if (viewConfig.loading) {
      <app-spinner class="mt-2"></app-spinner>
      } @else if (documentFileViewConfig.loading) {
      <app-spinner class="mt-2" [label]="'Loading Document...'"></app-spinner>
      } @else if (viewConfig.error) {
      <ngb-alert
        class="mt-2"
        (closed)="viewConfig.setDefault()"
        type="danger"
        >{{ viewConfig.error }}</ngb-alert
      >
      } @else if (documentFileViewConfig.error) {
      <ngb-alert
        class="mt-2"
        (closed)="documentFileViewConfig.setDefault()"
        type="danger"
        >{{ documentFileViewConfig.error }}</ngb-alert
      >
      }
    </div>
    <div class="col-12 p-0 col-md-6">
      <div class="ind-document-file">
        @if (fileUrl) { @if (isDocumentTypePdf(documentDetails.fileType)) {
        <app-pdf-viewer
          [src]="fileUrl"
          (load)="onPdfLoad()"
          [page]="page"
          (expand)="onPdfExpand()"
        >
        </app-pdf-viewer>
        } @else if (isDocumentTypeJpg(documentDetails.fileType) ||
        isDocumentTypePng(documentDetails.fileType)) {
        <img
          class="canvas-container"
          [src]="fileUrl"
          [addAaTags]="documentDetails.name"
        />
        } }
        <div class="canvas-container">
          <canvas #canvas></canvas>
        </div>
      </div>
    </div>
    <div class="col-12 p-0 col-md-6">
      <div class="container p-4 ind-document-metadata">
        <nav
          class="ind-document-search-results-nav"
          aria-label="Search results: links to each page in the document viewer"
        >
          <div class="row d-flex align-items-center mb-3">
            <div class="col-3 col-md-6">
              <h2 class="ind-document-metadata-title h6 mb-0">
                Search Results
              </h2>
            </div>
            <div class="col-3 col-md-6" *ngIf="showShowAllButton">
              <div class="ind-document-metadata-title-show-all">
                <a
                  href="javascript:void(0)"
                  aria-label="Show all search result pages"
                  (click)="reset()"
                  (keydown.enter)="reset()"
                  (keydown.space)="reset()"
                  >Show All</a
                >
              </div>
            </div>
          </div>
          <div class="wrapper ind-document-metadata-content">
          <table class="table ind-table table-hover">
            <thead class="ind-table-thead">
              <tr>
                <th scope="col">Location</th>
                <th scope="col" class="w-40">Division</th>
                <th scope="col" class="w-60">Details</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let page of documentDetails?.pages;
                  let pageIndex = index
                "
              >
                <td>
                  <app-button
                    (click)="navigateToPdfPage(page.pageNumber)"
                    (keydown.enter)="navigateToPdfPage(page.pageNumber)"
                    (keydown.space)="navigateToPdfPage(page.pageNumber)"
                    type="link"
                    class="link-underline link-underline-opacity-0"
                    label="Page {{ page.pageNumber }}"
                  ></app-button>
                </td>
                <td class="w-40">{{ page.documentCategory }}</td>
                <td class="w-60">
                  <ul>
                    <li *ngFor="let item of page.calculatedDetails">
                      <b>{{ item.key }}</b
                      >: {{ item.value }}
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>
